import { render, staticRenderFns } from "./FeeDeposit.vue?vue&type=template&id=89e5b572&scoped=true"
import script from "./FeeDeposit.vue?vue&type=script&lang=js"
export * from "./FeeDeposit.vue?vue&type=script&lang=js"
import style0 from "./FeeDeposit.vue?vue&type=style&index=0&id=89e5b572&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e5b572",
  null
  
)

export default component.exports